import React, { useRef, useState } from "react";
import {
    useId,
    Button,
    ToastPosition,
    Toaster,
    useToastController,
    ToastTitle,
    Toast,
    Link,
    ToastTrigger,
} from "@fluentui/react-components";
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './toaster.css'

export const Toastr = React.forwardRef((props, ref) => {
    const toasterId = useId("toaster");
    const { dispatchToast } = useToastController(toasterId);
    const [horizontal, setHorizontal] = React.useState(25);
    const [vertical, setVertical] = React.useState(50);
    const toastButtonRef = useRef<HTMLButtonElement>(null); // Explicitly defining the type of toastButtonRef
    const [toasterData, setIsSelected] = useState({ message: '', type: '' });

    React.useImperativeHandle(ref, () => ({
        triggerToastButtonClick(toaster: any) {
            setIsSelected(toaster);
            setTimeout(() => {
                if (toastButtonRef.current) {
                    (toastButtonRef.current as HTMLButtonElement).click(); // Type assertion to HTMLButtonElement
                }
            }, 0);
        },
    }));

    const toasterBackground = () => {
        switch (toasterData.type) {
            case "success":
                return "#43BC6B";
            case "error":
                return "#F50100";
            case "info":
                return "#0C79FE";
            case "warning":
                return "#FFB900";
            default:
                return "#F50100";
        }
    };

    const toastStyle = {
        background: toasterBackground(),
        color: 'white',
        padding: '10px',
        borderRadius: '7px',
        fontSize: '16px',
        fontWeight: '500',
        paddingTop: '7px'
    };

    const iconStyle = {
        fontSize: '18px',
        paddingTop: '2px'
    }

    const titleStyle = {
        color: 'white',
    };

    const notify = () => {
        dispatchToast(
            <Toast style={toastStyle}>
                <ToastTitle
                    action={
                        <ToastTrigger>
                            <Link style={titleStyle}><FontAwesomeIcon icon={faClose} className="font-icon" style={iconStyle} /></Link>
                        </ToastTrigger>
                    }
                    style={titleStyle}>{toasterData.message}</ToastTitle>
            </Toast>,
            { position: "top-end", intent: toasterType(), timeout: 4000, pauseOnHover: true }
        );
    };

    const toasterType = () => {
        switch (toasterData.type) {
            case "success":
                return "success";
            case "error":
                return "error";
            case "info":
                return "info";
            case "warning":
                return "warning";
            default:
                return "error";
        }
    };

    return (
        <>
            <Button ref={toastButtonRef} style={{ display: "none" }} onClick={notify} />
            <Toaster toasterId={toasterId} offset={{ horizontal, vertical }} />
            {/* limit={1} */}
        </>
    );
});

export default Toastr;
